import React, { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import { useDispatch, useSelector } from "react-redux";
import reportslogo from "../../assets/images/reportslogo.png";
import CryptoJS from "crypto-js";
import { encryptionKey } from '../../utility/secretKeys';
import { useLocation, useNavigate } from "react-router-dom";
import VendorWorkOrderEditForm from "./VendorWorkOrderEditForm";
import AttachmentsEditForm from "./AttachmentsEditForm";
import { ErrorChips, SuccessChips, WarningChips } from "../../assets/styled-components/chips";


const VendorStepperForm = () => {

  const [page, setPage] = useState("Vendor WorkOrder Edit");
  const [decryptData, setDecryptData] = useState({});
  const webFormData = useSelector((state) => state.vendorWebForm);
  const workOrderNo = webFormData?.respondedDetails?.workOrderNo || "";

  const location = useLocation();

  const workOrderId = decryptData?.WorkorderId || "";
  const workOrderType = decryptData?.Workordertype || "";
  const assetCategroyType = decryptData?.Service || "";
  const categoryType = decryptData?.Category || "";
  const categoryTypeId = decryptData?.CategoryId || "";
  const status = webFormData?.workderStatus || "";
  const statusID = status ? status : decryptData?.statusId || "";
    
  const statusMapping = {
      2: <ErrorChips label ={"Scheduled"} />,
      3: <WarningChips label ={"In Progress"} />,
      10: <WarningChips label ={"In Progress-Outsource"} />,
      4: <SuccessChips label ={"Completed"} />,
      9: <SuccessChips label ={"Completed-Outsource"} />,
      5: <SuccessChips label ={"Closed"} />,
      6: <ErrorChips label ={"Cancelled"} />,
      8: <SuccessChips label ={"Verified"} />,
  };
      

  // Map the current status to the corresponding number
  const mappedStatus = statusMapping[statusID] || null;

  const decrypt = async (key, content) => {
    try {
      // Ensure the key is exactly 32 bytes (256 bits) for AES-256
      let keyBytes = CryptoJS.enc.Utf8.parse(key);
      let keyWords = keyBytes.words.slice(0, 8);  // AES-256 uses 8 words (32 bytes)
      let truncatedKey = CryptoJS.lib.WordArray.create(keyWords, 32);

      // Convert base64-encoded content back to bytes
      let encryptedBytes = CryptoJS.enc.Base64.parse(content);

      // Extract IV from the beginning of the encrypted data
      let iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);

      // Extract the actual encrypted data
      let encryptedData = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4), encryptedBytes.sigBytes - 16);

      // Decrypt the data
      let decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedData },
        truncatedKey,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      // Handle exceptions related to decryption
      console.error('Decryption error:', error.message);
      throw error;
    }
  }

  useEffect(() => {
    const getToken = async () => {
      try {
        const encodedToken = location.search.replace('token=', '');
        const cleanToken = encodedToken.startsWith('?') ? encodedToken.replace('?', '') : encodedToken;
        const decryptedContent = await decrypt(encryptionKey, cleanToken);
        const parsedData = JSON.parse(decryptedContent);
        setDecryptData(parsedData)
      } catch (error) {
        console.error(error.message);
      }
    }
    getToken();
  }, []);

  const buttonAttributes = [
    {
      currentPageName: "Vendor WorkOrder Edit",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Continue",
      backButtonName: "",
      backButton: false,
      nextPageName: "Attachments & Signature",
      previousPageName: "",
    },
    {
      currentPageName: "Attachments & Signature",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Submit",
      backButtonName: "Back",
      backButton: true,
      nextPageName: "Attachments & Signature",
      previousPageName: "Vendor WorkOrder Edit",
    }
  ];

  const renderPageContent = () => {
    switch (page) {
      case "Vendor WorkOrder Edit":
        return (
          <VendorWorkOrderEditForm
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
            locationState={{ workorderId: workOrderId,workOrderType:workOrderType, serviceType: assetCategroyType, categoryType: categoryType, bottomButtons: false,categoryId:categoryTypeId,woStatus:status }}
          />
        );
      case "Attachments & Signature":
        return (
          <AttachmentsEditForm
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
            locationState={{ workorderId: workOrderId,workOrderType:workOrderType, serviceType: assetCategroyType, categoryType: categoryType, bottomButtons: false, categoryId:categoryTypeId,woStatus:status }}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Grid item xs={12} sm={8.6} md={9.8}>
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
          <img src={reportslogo} alt="logo" width={"8%"} style={{ marginTop: '2px' }} />
          <Typography variant="h4" sx={{ fontWeight: 'bold', ml: 2 }}>
            Vendor Work Order
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

        </Stack>

        <DefaultCard sx={{ height: "100%" }}>
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={"5px"}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 2 }}>
                {workOrderNo} - Edit Work Order
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              {mappedStatus}
            </Stack>
          {renderPageContent()}
        </DefaultCard>
      </Grid>

    </>
  );
}

export default VendorStepperForm;
